
import Login from "../Auth/Login.vue";
import Signup from "../Auth/SignUp.vue";
export default {
  name: "NavComponent",
  components: {
    Login,
    Signup,
  },
  data() {
    return {
  	open: false,
    }
  },
    methods: {
  	toggle() {
    	this.open = !this.open
    }
  }
};
